export default {
  full_menu: "Full Menu",
  free: "FREE",
};
